export default __webpack_public_path__ + "static/media/poster.2fd0289d.svg";